export enum MoveToCofeeAction {
  ADD_TO_MEMBER_LIST = 'ADD_TO_MEMBER_LIST',
  QUICK_COLLECT = 'QUICK_COLLECT',
  QUICK_COLLECT_ADD_TO_GROUP = 'QUICK_COLLECT_ADD_TO_GROUP'
}

export const MOVE_TO_COFEE_OPTIONS = [
  {
    id: MoveToCofeeAction.ADD_TO_MEMBER_LIST,
    label: 'Add to Member List',
    description:
      'Adds this lead as a member to a branch or group. No payment link will be sent.'
  },
  {
    id: MoveToCofeeAction.QUICK_COLLECT,
    label: 'Quick Collect ( No Group )',
    description:
      'Sends a payment link immediately. Lead is added to the branch member list only.'
  },
  {
    id: MoveToCofeeAction.QUICK_COLLECT_ADD_TO_GROUP,
    label: 'Quick Collect + Add to Group',
    description:
      'Sends a payment link and the lead to a specific fee group in a branch'
  }
];

export enum MoveToCofeeStep {
  CHOOSE_ACTION = 0,
  CONFIGURE = 1,
  REVIEW = 2
}

export const STEPPER_LABELS = [
  'Choose Action',
  'Configure',
  'Review & Confirm'
];
